<div class="notifications-page">
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">
        <i class="pi pi-bell"></i>
        Notifications
      </h1>
      <p class="page-subtitle">Manage all your notifications in one place</p>
    </div>
    <div class="header-actions">
      <button 
        pButton 
        type="button"
        i18n-label
        label="Mark All as Read"
        icon="pi pi-check"
        class="p-button-outlined"
        [disabled]="allNotificationsRead()"
        (click)="markAllAsRead()"
        [style]="{'width': '100%', 'min-height': '2.75rem'}">
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-container">
    <div class="filters-header">
      <h3 class="filters-title">Filters</h3>
      <button 
        pButton 
        type="button"
        i18n-label
        label="Clear"
        icon="pi pi-times"
        class="p-button-text p-button-sm clear-filters-btn"
        [disabled]="selectedTypeFilter === 'all' && selectedReadFilter === 'all' && selectedPriorityFilter === 'all'"
        (click)="clearFilters()">
      </button>
    </div>
    <div class="filters-grid">
      <div class="filter-item">
        <label>Type</label>
        <p-select 
          [(ngModel)]="selectedTypeFilter" 
          [options]="typeFilters"
          optionLabel="label"
          optionValue="value"
          placeholder="All Types" i18n-placeholder
          [style]="{'width': '100%'}"
          (onChange)="onFilterChange()">
        </p-select>
      </div>

      <div class="filter-item">
        <label>Status</label>
        <p-select 
          [(ngModel)]="selectedReadFilter" 
          [options]="readFilters"
          optionLabel="label"
          optionValue="value"
          placeholder="All" i18n-placeholder
          [style]="{'width': '100%'}"
          (onChange)="onFilterChange()">
        </p-select>
      </div>

      <div class="filter-item">
        <label>Priority</label>
        <p-select 
          [(ngModel)]="selectedPriorityFilter" 
          [options]="priorityFilters"
          optionLabel="label"
          optionValue="value"
          placeholder="All Priorities" i18n-placeholder
          [style]="{'width': '100%'}"
          (onChange)="onFilterChange()">
        </p-select>
      </div>
    </div>
  </div>

  <!-- Results Summary -->
  <div class="results-summary">
    <span class="results-count">
      <strong>{{totalRecords}}</strong> notification{{totalRecords !== 1 ? 's' : ''}}
    </span>
  </div>

  <!-- Notifications List -->
  <div class="notifications-list">
    <!-- Loading state -->
    <div *ngIf="loading" class="loading-state">
      <i class="pi pi-spinner pi-spin"></i>
      <p i18n>Loading notifications...</p>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && notifications.length === 0" class="empty-state">
      <i class="pi pi-bell-slash"></i>
      <h3 i18n>No Notifications</h3>
      <p i18n>You're all caught up! No notifications to display.</p>
    </div>

    <!-- Notification items -->
    <p-card 
      *ngFor="let notification of notifications" 
      class="notification-card"
      [ngClass]="{
        'unread': !notification.isRead,
        'priority-urgent': notification.priority === 'URGENT',
        'priority-high': notification.priority === 'HIGH'
      }">
      
      <div class="notification-card-content" (click)="handleNotificationClick(notification)">
        <!-- Icon and Priority Badge -->
        <div class="notification-left">
          <div class="notification-icon-wrapper">
            <i [class]="getIconClass(notification)" class="notification-icon"></i>
          </div>
        </div>

        <!-- Content -->
        <div class="notification-main-content">
          <div class="notification-header-row">
            <h3 class="notification-card-title">{{ notification.title }}</h3>
            <p-tag 
              [value]="notification.priority" 
              [severity]="getPrioritySeverity(notification.priority)"
              class="priority-tag">
            </p-tag>
          </div>

          <p class="notification-card-message">{{ notification.message }}</p>

          <div class="notification-meta">
            <span class="notification-time">
              <i class="pi pi-clock"></i>
              {{ getTimeAgo(notification.createdAt) }}
            </span>
            <span *ngIf="notification.metadata?.actionLabel" class="notification-action-label">
              <i class="pi pi-arrow-right"></i>
              {{ notification.metadata?.actionLabel }}
            </span>
          </div>
        </div>

        <!-- Actions -->
        <div class="notification-actions">
          <button 
            *ngIf="!notification.isRead"
            pButton 
            type="button"
            icon="pi pi-check"
            class="p-button-rounded p-button-text p-button-sm"
            pTooltip="Mark as read"
            tooltipPosition="left"
            (click)="markAsRead(notification, $event)"
            [attr.aria-label]="'Mark as read'">
          </button>
          
          <button 
            pButton 
            type="button"
            icon="pi pi-trash"
            class="p-button-rounded p-button-text p-button-sm p-button-danger"
            pTooltip="Delete"
            tooltipPosition="left"
            (click)="deleteNotification(notification, $event)"
            [attr.aria-label]="'Delete notification'">
          </button>

          <!-- Unread indicator -->
          <div class="unread-dot" *ngIf="!notification.isRead" [attr.aria-label]="'Unread notification'"></div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<p-confirmDialog></p-confirmDialog>

